import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { IndicadorCliente } from 'src/app/admihair/api/dto/indicador-cliente';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { IndicadorClienteService } from 'src/app/admihair/service/indicador-cliente.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-indicador-cliente-inserir',
  templateUrl: './indicador-cliente-inserir.component.html',
  styleUrls: ['./indicador-cliente-inserir.component.scss']
})
export class IndicadorClienteInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  progressoRequisicao: boolean = false;
  value?: string;

  constructor(private indicadorClienteService: IndicadorClienteService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_CANAL_DE_INDICACAO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
  }

  salvar() {
    this.progressoRequisicao = true;
    const indicadorCliente: IndicadorCliente = this.form?.form.value;
    indicadorCliente.empresa = this.empresaSelecionada;
    indicadorCliente.tipo = 'INDICADOR';
    this.indicadorClienteService.salvar(indicadorCliente).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMsg() {
    this.messagemVisivel = false;
  }
}
